import { IconType } from "react-icons";
import "./LinkItem.css";

interface LinkItemProps {
  icon: IconType;
  link: string;
  delay?: number;
}

function LinkItem({ icon: Icon, link, delay = 0 }: LinkItemProps) {

  return (
    <div 
      className="link-item group" 
      style={{ animationDelay: `${delay}ms` }}
    >
      <a 
        href={link} 
        className="a-icon relative overflow-hidden rounded-full"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Visit ${link}`}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-accent/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <Icon className="link-icon relative z-10 group-hover:scale-110 transition-transform duration-300" />
      </a>
    </div>
  );
}

export default LinkItem;
